import React from 'react'
import { GoogleMap, Marker, DirectionsRenderer } from '@react-google-maps/api';

const Map = ({ startPlace, endPlace, directions }) => {
    const mapOptions = {
        disableDefaultUI: true,
    };
    const mapStyles = {
        height: '400px',
        width: '100%',
    };
    return (
        <>
            <GoogleMap options={mapOptions} mapContainerStyle={mapStyles} center={{ lat: 0, lng: 0 }} zoom={12}>
                {startPlace && <Marker position={startPlace?.geometry?.location} />}
                {endPlace && <Marker position={endPlace?.geometry?.location} />}
                {directions && (
                    <DirectionsRenderer
                        directions={directions}
                        options={{ suppressMarkers: true }}
                    />
                )}
            </GoogleMap>
        </>
    )
}

export default Map
